import PropTypes from 'prop-types';
import { USER_TYPES } from '../../../auth/constants';

export const staffMemberProp = PropTypes.shape({
  id: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  kind: PropTypes.oneOf([USER_TYPES.shop]).isRequired,
  brandId: PropTypes.string,
});

export const staffMembersProp = PropTypes.arrayOf(staffMemberProp);
